package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing

@Composable
fun ItineraryServiceStatusDropDown(
    status: ItineraryServiceModel.Status?,
    onStatusSelected: (ItineraryServiceModel.Status) -> Unit,
) {
    var isExpanded by remember {
        mutableStateOf(false)
    }

    Box {
        ItineraryServiceStatus(
            status = status,
            suffixIconRes = if (isExpanded) EsIcons.ArrowUp else EsIcons.ArrowDown,
            modifier = Modifier
                .clip(CircleShape)
                .pointerHoverIcon(PointerIcon.Hand)
                .focusProperties { canFocus = false }
                .clickable {
                    isExpanded = true
                },
        )

        EsDropDownMenu(
            expanded = isExpanded,
            onDismissRequest = { isExpanded = false },
            paddingValues = PaddingValues(1.spacing),
            verticalArrangement = Arrangement.spacedBy(1.5f.spacing),
        ) {
            ItineraryServiceModel.Status.entries.forEach { status ->
                ItineraryServiceStatus(
                    status = status,
                    modifier = Modifier
                        .clip(CircleShape)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .focusProperties { canFocus = false }
                        .clickable {
                            onStatusSelected(status)
                            isExpanded = false
                        },
                )
            }
        }
    }
}